import { Chip } from '@heroui/react';
import { ReactNode } from 'react';

export const Filter = ({
  children,
  isSelected = false,
  onPress,
}: {
  children?: ReactNode;
  isSelected?: boolean;
  onPress?: () => void;
}) => {
  return (
    <Chip
      variant={isSelected ? 'solid' : 'flat'}
      color={isSelected ? 'primary' : 'default'}
      onClose={isSelected ? () => {} : undefined}
      isCloseable
      onClick={onPress}
    >
      {children}
    </Chip>
  );
};
